export enum SortingOrder {
  Ascending = "asc",
  Descending = "desc",
}
